import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button, Stack, Typography } from "@mui/material";
import { IconCheck, IconX } from "@tabler/icons-react";

const MercadoPagoCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const status = searchParams.get("status");
  const message = searchParams.get("message");

  const success = status === "success";

  // Limpa os params da URL sem reload
  useEffect(() => {
    window.history.replaceState({}, "", "/mercadopago/callback");
  }, []);

  return (
    <Stack alignItems="center" justifyContent="center" minHeight="60vh" gap={2}>
      {success ? (
        <>
          <IconCheck size={48} color="green" />
          <Typography fontSize={22} fontWeight={700}>
            Mercado Pago conectado!
          </Typography>
          <Typography color="text.secondary">
            Sua conta foi vinculada com sucesso.
          </Typography>
        </>
      ) : (
        <>
          <IconX size={48} color="red" />
          <Typography fontSize={22} fontWeight={700}>
            Erro ao conectar
          </Typography>
          <Typography color="text.secondary">
            {message ?? "Não foi possível vincular sua conta do Mercado Pago."}
          </Typography>
        </>
      )}

      <Button variant="contained" onClick={() => navigate("/financeiro")}>
        Voltar ao financeiro
      </Button>
    </Stack>
  );
};

export default MercadoPagoCallback;
